import { DATETIME_FORMATS, DateUtils } from '@/common/utils';

export const FormattedDate = ({
  prefix,
  date,
}: {
  prefix?: string;
  date: Date | number | string | null | undefined;
}) => (
  <>
    {prefix && `${prefix}: `}
    {DateUtils.formatDate(date, DATETIME_FORMATS.MMMddyyyy)}
  </>
);
